import {
    Button, ClickEvent, CrudDecorator, DataDisplayEvent, DataSourceMode, EdiLocation, Label, Layout, Location, Snackbar,
    TableCell, TableRow, TableRowDisplayEvent, Textbox, Toast
} from "@mcleod/components";
import { Api, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutDataFusionLocationCrossReference } from "./autogen/AutogenLayoutDataFusionLocationCrossReference";
import { getDispatchControlBoolean } from "@mcleod/general";
import { Location as LocationLayout } from "@mcleod/dispatch/src/Location";
import { ImageName } from "@mcleod/images";

export class DataFusionLocationCrossReference extends AutogenLayoutDataFusionLocationCrossReference {
    private _tenderId: string;
    private _ediOrderRow: TableRow;
    private _shipperLocReq: string = "N";
    private _partnerId: string;
    private _versionId: string;
    saveButtonClicked: boolean = false;

    override onLoad() {
        this.sourceEdiStop.search({ order_id: this._tenderId }).then(() => this.sourceEdiStop.mode = DataSourceMode.UPDATE);
    }

    set shipperLocReq(req: string) {
        this._shipperLocReq = req;
    }

    onStopTypeDisplay(event: DataDisplayEvent) {
        const stopTypeLabel = <Label>event.target;
        const stopType = event.rowData.get("stop_type");
        if (stopType == "PU") {
            stopTypeLabel.text = "Pickup";
        } else if (stopType == "SO") {
            stopTypeLabel.text = "Delivery";
        }

    }

    onRowDataDisplay(event: DataDisplayEvent) {
        const locId = event.rowData.get("location_id");
        const address = event.rowData.get("address");
        const state =  event.rowData.get("state");
        const city = event.rowData.get("city_name");
        const zipCode = event.rowData.get("zip_code");
        const locationName = event.rowData.get("location_name");
        const orderSequence = event.rowData.get("order_sequence");
        const locIdTextbox = (event.target as TableCell).findComponentById("textboxLocationId") as Location;
        const buttonCreateNewMasterfile = (event.target as TableCell).findComponentById("buttonCreateNewMasterfile") as Button;
        const labelXref = (event.target as TableCell).findComponentById("dfXref") as Label;
        locIdTextbox.textCombined.manualAddLayout = null;
        if ((!StringUtil.isEmptyString(locId) && StringUtil.isEmptyString(locIdTextbox.textCombined.text))) {
            locIdTextbox.textCombined.text = locationName + ", " + address + ", " + city + ", " + state + " " + zipCode;
        }
        if (this._shipperLocReq === "Y" && orderSequence == 1) {
            locIdTextbox.required = true;
            locIdTextbox.textCombined.placeholder = "Required";
        }
        if(!StringUtil.isEmptyString(locIdTextbox.textCombined.text)){
            buttonCreateNewMasterfile.visible = false;
        }
        this.updateLabelXref(locId, labelXref);
    }

    onTableRowDisplay(event: TableRowDisplayEvent) {
        const row: TableRow = event.getTableRow();
        const modelRow: ModelRow = row.data as ModelRow;
        const locCodeTextbox = (event.target as TableRow).findComponentById("textboxLocationCode") as Textbox
        locCodeTextbox.text = modelRow.get("location_id");
        if (locCodeTextbox.enabled == false) {
            locCodeTextbox.color = "default.lighter";
        }
        const locIdTextbox = (event.target as TableRow).findComponentById("textboxLocationId") as EdiLocation;
        locIdTextbox.captionVisible = true;
        if (!locIdTextbox["__changeListenerBound"]) {
            locIdTextbox.addChangeListener(event => {
                locCodeTextbox.text = modelRow.get("location_id");
            });
            locIdTextbox["__changeListenerBound"] = true;
        }

        const address2 = modelRow.get("address2");
        const address2Label = (event.target as TableRow).findComponentById("labelAddress2") as Label;
        if (address2Label) {
            address2Label.visible = !StringUtil.isEmptyString(address2);
        }

        //adding focusListener to display the caption due to this component not haveing the "captionVisibleInsideTable" property.
        locIdTextbox.addFocusListener(event => locIdTextbox.captionVisible = true);
        if(getDispatchControlBoolean("enable_location_add_google") === true){
            locIdTextbox.googlePlacesProps = {
                enableSearch: getDispatchControlBoolean("enable_google_places"),
                createLocations: getDispatchControlBoolean("create_location_from_stop"),
                customerId: "",
                doBeforeGoogleLocationCreated: () => locIdTextbox.captionVisible = true,
                doAfterGoogleLocationCreated: () => locIdTextbox.captionVisible = true
            };
        }
        locIdTextbox.textCombined.quickInfoOverrideKeyValue = () => {
            return modelRow.get("location_id");
        }

        event.preventDefault();
    }

    buttonCreateNewMasterfileOnClick(event: ClickEvent){
        const locLayout = Layout.getLayout("lme/dispatch/Location", { paddingBottom: 25 }) as LocationLayout;
        const tableRow = TableRow.getContainingTableRow(event.target as Button);
        const data = tableRow.data;
        const locName = data.get("location_name");
        const locAdress = data.get("address");
        const locAdress2 = data.get("address2");
        const locCity = data.get("city_name");
        const locState = data.get("state");
        const locZip = data.get("zip_code");
        const locCityID = data.get("city_id") as string;
        const contactName = data.get("contact_name");
        const contactPhone = data.get("phone");

        new CrudDecorator({
            layout: locLayout,
            mode: DataSourceMode.ADD,
            headerProps: {showClose: true, showSaveAndClose: true},
            doAfterSlideIn: (decorator: CrudDecorator) =>{
                locLayout.setAddLocationData(locName, locAdress, locAdress2, locCity, locState, locZip, locCityID, contactName, contactPhone)
            },
            doAfterSlideOut : async () => {
                const savedLocId = locLayout.activeRow.get("id");
                if(savedLocId != undefined){
                    Toast.showSuccessToast("Location created successfully for " + locName);
                }
            }
        }).slideIn();
    }

    afterExecution() {
        this.sourceEdiStop.data.forEach(data => data.set("original_loc_id", data.get("location_id")));
    }

    async saveOnClick(event: ClickEvent) {
        this.saveButtonClicked = true;
        const partnerId = this.ediOrderRow ? this._ediOrderRow.data.get("partner_id") : this.partnerId;
        const version = this.ediOrderRow ? this._ediOrderRow.data.get("version") : this.versionId;
        let missingLocId: boolean = false;
        let savedNewLoc: boolean = false;
        for (let x = 0; x < this.tableXref.rowCount; x++) {
            const ediLoc = this.tableXref.data[x].get("edi_loc_code");
            const loc = this.tableXref.data[x].get("location_id");
            const stopNo = this.tableXref.data[x].get("order_sequence");
            const originalLoc = this.tableXref.data[x].get("original_loc_id");
            if (!StringUtil.isEmptyString(loc) && originalLoc !== loc) {
                await this.tableXref.data[x].post().then(await
                    Api.post("lme/datafusion/add-location-xref", {
                    "partner_id": partnerId,
                    "version": version,
                    "edi_location": ediLoc,
                    "location_id": loc
                }));
                savedNewLoc = true;
            } else if (stopNo == "1" && this._shipperLocReq == "Y" && StringUtil.isEmptyString(loc)) {
                const tableRow = this.tableXref.getRowByIndex(0);
                const locIdTextbox = tableRow.findComponentById("textboxLocationId") as Textbox;
                locIdTextbox.validateSimple();
                missingLocId = true;
            }
        }
        if (!missingLocId) {
            await this.slideOut();
            if (savedNewLoc) {
                Toast.showSuccessToast("DataFusion location cross reference added.");
            }
        } else {
            Snackbar.showWarningSnackbar("Missing required shipper location code");
        }
    }

    get tenderId(): string {
        return this._tenderId;
    }
    set tenderId(value: string) {
        this._tenderId = value;
    }

    set ediOrderRow(row: TableRow) {
        this._ediOrderRow = row;
    }
    get ediOrderRow(): TableRow {
        return this._ediOrderRow;
    }

    get partnerId(): string {
        return this._partnerId;
    }

    set partnerId(value: string) {
        this._partnerId = value;
    }

    get versionId(): string {
        return this._versionId;
    }

    set versionId(value: string) {
        this._versionId = value;
    }

    private updateLabelXref(locId: any, labelXref: Label) {
        if (locId == undefined || locId == "") {
            this.setLabelXrefProperties(labelXref, true, ImageName.cross_ref_missing, "default.darkest", "Location is missing a cross reference to DataFusion location.");
        } else {
            if (labelXref != undefined) {
                this.setLabelXrefProperties(labelXref, true, ImageName.cross_ref_confirmed, "default.darkest", "Location cross reference successfully applied");
            }
        }
    }

    private setLabelXrefProperties(labelXref: Label, visible: boolean, imageName: ImageName, imageColor: string, tooltip: string) {
        labelXref.visible = visible;
        labelXref.imageName = imageName;
        labelXref.imageColor = imageColor;
        labelXref.tooltip = tooltip;
    }
}
